
import {getUserInfoFetch} from '@/api/userApi'
import {getToken, setToken, removeToken} from '@/utils/auth'
import util from '@/utils/util';
/**
 * 用户相关
 */
const user = {
  state: {
    token: getToken(),  // 登录token
    userInfo:{},  // 用户信息
    isIphoneX: false,  // 是否苹果x
    playMusic: true,  // 是否播放音乐
    toHualuoMusic: false,  // 进入花落前音乐播放状态
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_IPHONEX: (state, isIphoneX) => {
      state.isIphoneX = isIphoneX
    },
    SET_MUSIC: (state, playMusic) => {
      state.playMusic = playMusic
    },
    SET_HUALUOMUSIC: (state, toHualuoMusic) => {
      state.toHualuoMusic = toHualuoMusic
    }
  },

  actions: {
    // iPhoneX
    GetModelType({commit}, isIphoneX) {
      return new Promise(resolve => {
        commit('SET_IPHONEX', isIphoneX)
        resolve()
      })
    },
    // 是否播放背景音乐
    GetUserMusic({commit}, playMusic) {
      return new Promise(resolve=>{
        commit('SET_MUSIC', playMusic)
        resolve()
      })
    },
    // 进入花落前的音乐播放状态
    GetHuoLuoMusicType({commit}, playMusic) {
      return new Promise(resolve=>{
        commit('SET_HUALUOMUSIC', playMusic)
        resolve()
      })
    },
    // 登录成功，有了userId，请求用户信息接口获取用户数据
    GetUserInfo({commit}, token) {
      return new Promise((resolve, reject) => {
        getUserInfoFetch().then(res => {
          console.log('获取个人信息成功', res.data);
          res.data.encryptionPhone = util.encryptionPhone(res.data.mobile)
          commit('SET_USER_INFO', res.data)
          resolve(res);
        }).catch(err => {
            console.log('获取个人信息失败', err);
            alert({
              title: '错误提示',
              content: '获取用户信息失败，请检查网络或者稍后重试'
            });
            reject(err)
        })
      })
    },
    // 在"我的"页面,获取用户信息后直接将用户信息赋值到全局用户信息
    DirectGetUserInfo({commit}, userInfo) {
      return new Promise(resolve => {
        commit('SET_USER_INFO', userInfo)
        resolve()
      })
    },
    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_USER_INFO', '')
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js